module.exports = __webpack_public_path__ + "static/img/feiqinzoushou.2e15a29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/feiqinzoushou.jpg
// module id = aekv
// module chunks = 0